export default "__VITE_ASSET__1_HohP20__"